import ProductAdapter from 'Services/Adapters/SearchEngineBeta/ProductAdapter';

export default class DeclinationAdapter extends ProductAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'declination';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = DeclinationAdapter._key;
    }
}
